import { _ } from "../../../core/polyglot/polyglot.js";
import abstractFolderView from "./abstractFolderView.js";
import DocumentArchiveBreadCrumbsWidget from "./DocumentArchiveBreadCrumbsWidget.js";
import selectionEventsManager from "../folders/selectionEventsManager.js";
import sortingStrategies from "../folders/sortingStrategies.js";

/**
 * I am a concrete implementation of abstractFolderWidget used to display the entries in a list.
 */

/**
 * Todo: Add JSDoc comment
 */
function listFolderView(spec, my) {
	spec ||= {};
	my ||= {};

	const that = abstractFolderView(spec, my);

	my.renderEntryWidgetsOn = function (widgets, html) {
		html.div(
			{ klass: "col-lg-12" },
			html.table(
				{ klass: "table table-bordered table-striped" },
				renderHeaderOn,
				html.tbody((html) => {
					my.renderBackOn(html);

					widgets.forEach((entryWidget) => {
						renderEntryWidgetOn(entryWidget, html);
					});
				}),
			),
		);
	};

	function renderHeaderOn(html) {
		html.thead(
			html.tr().render((row) => {
				row.th().render((html) => {
					renderColumnHeaderOn(html, {
						name: _("Name"),
						asc_item: sortingStrategies.sortByNameAZStrategy,
						desc_item: sortingStrategies.sortByNameZAStrategy,
					});
				});

				row.th().render(_("Type"));

				// TODO : Comment out until we have fixed FTGP-952

				// row.th().render(function(html) {
				// renderHeaderOn(html, {
				// name:      _('Last Modification'),
				// asc_item:  sortingStrategies.sortByModificationTimeAscStrategy,
				// desc_item: sortingStrategies.sortByModificationTimeDescStrategy
				// });
				// });

				row.th().render((html) => {
					renderColumnHeaderOn(html, {
						name: _("Creation"),
						asc_item:
							sortingStrategies.sortByCreationTimeAscStrategy,
						desc_item:
							sortingStrategies.sortByCreationTimeDescStrategy,
					});
				});
			}),
		);
	}

	my.renderBackToParentOn = function (html) {
		html.tr({
			id: "backWidget",
			klass: "entryWidget",
		})
			.render((row) => {
				row.td(
					{ klass: "back-to-parent" },
					html
						.tag("i")
						.addClass("fa fa-arrow-circle-up")
						.click(my.backToParent),
					html.a("..").click(my.backToParent),
				);

				row.td();
				row.td();
			})
			.dblclick(my.backToParent);
	};

	function renderEntryWidgetOn(entryWidget, html) {
		my.registerToEntryClick(entryWidget);
		entryWidget.renderListViewOn(html);

		entryWidget.checkboxClick(() => {
			selectionEventsManager.toggleEntrySelection({
				widget: entryWidget,
				entry: entryWidget.model(),
			});
		});
	}

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	function renderColumnHeaderOn(html, spec) {
		const name = spec.name;

		const asc_item = spec.asc_item;
		const desc_item = spec.desc_item;

		html.div().render((html) => {
			const anchor = html.a(`${name} `);
			let icon = null;
			if (my.sorter.currentSortMatch(asc_item)) {
				icon = asc_item.icon();
			}
			if (my.sorter.currentSortMatch(desc_item)) {
				icon = desc_item.icon();
			}
			if (icon !== null) {
				anchor.render((html) => {
					html.tag("i").addClass(icon);
				});
			}

			anchor.click(() => {
				if (my.sorter.currentSortMatch(asc_item)) {
					my.sorter.setCurrentStrategy(desc_item);
				} else {
					my.sorter.setCurrentStrategy(asc_item);
				}
				my.document.updateDocumentContent();
			});
		});
	}

	my.buildBreadcrumbs = function () {
		return new DocumentArchiveBreadCrumbsWidget({
			document: my.document,
			isIconicView: my.document.isIconicView.bind(my.document),
		});
	};

	my.cssClass = function () {
		return "listView";
	};

	return that;
}

export default listFolderView;
